import Vue from "vue";
import {
  BalanceTypes, BrokerBalanceTypes,
  Currencies, DocumentType, IdentificationTypes, LiquidityProviderBalanceTypes, LiquidityProviders,
  ManagementAccountingBalanceTypes,
  ManagementAccountingPostingTypes, QuestEvents, QuestTypes,
  USDTGatewayTypes
} from "@/interfaces/interfaces";
import {LimitOptions, OrderCancelReasonDto} from "@/interfaces/models/orders";

const autoSpaces = (value: string) => {
  if (!value) return ''
  return value.replace(/([a-z])([A-Z])/g, '$1 $2')
}

Vue.filter('autoSpaces', autoSpaces);

Vue.filter('limitOptions',  (value: string): string => {
  const items: any = {
    [LimitOptions.GoodTillCanceled]: 'GTC',
    [LimitOptions.ImmediateOrCancel]: 'IOC',
    [LimitOptions.GoodTillTime]: 'IOT',
  };

  return items[value] || value;
});

Vue.filter('balanceTypes',  (value: string): string => {
  const items: any = {
    // [BalanceTypes.ExecutedTrade]: 'Executed trade',
    [BalanceTypes.Exchange]: 'Exchange',
    [BalanceTypes.External]: 'External',
    [BalanceTypes.FundingFee]: 'Funding fee',
    [BalanceTypes.HoldOnOrders]: 'Hold on orders',
    [BalanceTypes.TradeBalance]: 'Trade balance',
    [BalanceTypes.TradingFee]: 'Trading fee',
    [BalanceTypes.HoldOnWithdrawals]: 'Hold On Withdrawals',
    [BalanceTypes.ReserveBalance]: 'Reserve Balance',
  };

  return items[value] || value;
});

Vue.filter('currencySymbol', (value: string): string => {
  const items: any = {
    'BTC': Currencies.BTC,
    'LTC': Currencies.LTC,
    'ETH': Currencies.ETH,
    'EUR': Currencies.EUR,
    'USD': Currencies.USD,
  };

  return items[value] || value;
});

Vue.filter('orderCancelReason', (value: string): string => {
  const items: any = {
    [OrderCancelReasonDto.CanceledByTrader]: 'Отменен трейдером',
    [OrderCancelReasonDto.NotEnoughMoney]: 'Недостаточно средств',
    [OrderCancelReasonDto.SlippageExceeded]: 'Проскальзывание превышено',
    [OrderCancelReasonDto.CanceledByBroker]: 'Отменен брокером',
  };

  return items[value] || value;
});

Vue.filter('managementAccountingBalanceTypes', (value: string): string => {
  const items: any = {
    [ManagementAccountingBalanceTypes.ClientsWallet]: 'Кошелек клиента',
    [ManagementAccountingBalanceTypes.PendingReceipts]: 'Ожидает зачисления',
    [ManagementAccountingBalanceTypes.OperationBalance]: 'Клиентский баланс',
    [ManagementAccountingBalanceTypes.NetworkFee]: 'Комиссия сети',
    [ManagementAccountingBalanceTypes.ToBeSend]: 'Отправляется',
    [ManagementAccountingBalanceTypes.BrokerBalance]: 'Брокерский баланс',
    [ManagementAccountingBalanceTypes.LiquidityProvider]: 'Liquidity Provider',
    [ManagementAccountingBalanceTypes.LiquidityProviderFee]: 'Liquidity Provider Fee',
    [ManagementAccountingBalanceTypes.TradeFee]: 'Trade Fee',
    [ManagementAccountingBalanceTypes.External]: 'External',
    [LiquidityProviderBalanceTypes.FundingFee]: 'Funding Fee',
    [BrokerBalanceTypes.ExternalSource]: 'Внешний кошелек'
  };

  return items[value] || value;
});

Vue.filter('managementAccountingPostingTypes', (value: string): string => {
  const items: any = {
    [ManagementAccountingPostingTypes.ClientsDeposit]: 'Депозит клиента',
    [ManagementAccountingPostingTypes.ClientsWithdrawal]: 'Вывод клиента',
    [ManagementAccountingPostingTypes.LiquidityProviderDeposit]: 'Депозит провайдера ликвидности',
    [ManagementAccountingPostingTypes.LiquidityProviderWithdrawal]: 'Вывод провайдера ликвидности',
    [ManagementAccountingPostingTypes.Trade]: 'Сделка',
    [ManagementAccountingPostingTypes.TradingFee]: 'Комиссия сделки',
    [ManagementAccountingPostingTypes.Manual]: 'Ручная проводка',
  };

  return items[value] || value;
});

Vue.filter('USDTGatewayTypes', (value: string): string => {
  const items: any = {
    [USDTGatewayTypes.USDT_Trc20]: 'UsdtTrc20'
  };

  return items[value] || value;
});

Vue.filter('questTypes', (value: string): string => {
  const items: any = {
    [QuestTypes.Login]: 'Login',
    [QuestTypes.PasswordRecovery]: 'Password Recovery',
    [QuestTypes.EmailChange]: 'Email Change',
    [QuestTypes.LostTwoFaCode]: 'Lost TwoFa Code',
    [QuestTypes.LostTwoFaCodeSupport]: 'Lost Two Fa Code Support',
    [QuestTypes.AccountUnblockSupport]: 'Account Unblock Support',
    [QuestTypes.IpBypassSupport]: 'Ip Bypass Support',
  };

  return items[value] || value;
});

Vue.filter('questEvents', (value: string): string => {
  const items: any = {
    [QuestEvents.InvalidTwoFa]: 'Invalid TwoFa',
    [QuestEvents.TwoFaConfirmed]: 'TwoFa Confirmed',
    [QuestEvents.SupportVerification]: 'Verification',
    [QuestEvents.SupportByPassLinkSent]: 'Bypass Link Sent',
    [QuestEvents.LinkSent]: 'Link Sent',
  };

  return items[value] || autoSpaces(value)
});

Vue.filter('documentTypes', (value: string): string => {
  const items: any = {
    [DocumentType.Passport]: 'Passport',
    [DocumentType.DrivingLicence]: 'Driving licence',
    [DocumentType.IdCard]: 'ID Card',
  };

  return items[value] || 'Document'
});

Vue.filter('identificationTypes', (value: string): string => {
  const items: any = {
    [IdentificationTypes.IdentityPrimary]: 'trade',
    [IdentificationTypes.SumSubPrimary]: 'SumSub',
    [IdentificationTypes.KycPlatform]: 'KycPlatform',
  };

  return items[value] || autoSpaces(value)
});

Vue.filter('liquidityProviders', (value: string): string => {
  const items: any = {
    [LiquidityProviders.All]: 'Все',
    [LiquidityProviders.Binance]: 'Binance',
    [LiquidityProviders.Okex]: 'Okex',
    [LiquidityProviders.Netex24]: 'Netex24',
    [LiquidityProviders.Garantex]: 'Garantex',
    [LiquidityProviders.Bitfinex]: 'Bitfinex',
    [LiquidityProviders.ProviderEmulator1]: 'Emulator1',
    [LiquidityProviders.ProviderEmulator2]: 'Emulator2',
    [LiquidityProviders.ProviderEmulator3]: 'Emulator3',
  };

  return items[value] || autoSpaces(value)
});
